<template>
    <div class="view">
        <!-- Header -->
        <div class="page-top text-center text-md-left">
            <div class="container h-100">
                <div class="row h-100 d-flex align-items-center justify-content-between">
                    <div class="col-md-5 mt-5 mt-md-0">
                        <h2 class="h1-responsive mb-4">{{ msg.header.title }}</h2>
                        <p>{{ msg.header.text }}</p>
                    </div>
                    <div class="col-md-6">
                        <div class="pill-1 light-green"></div>
                        <img src="../assets/mobileapps.png" class="w-75 z-depth-1-half mx-auto" alt="Image">
                    </div>
                </div>
            </div>
        </div>

        <hr class="container d-none d-md-block">

        <!-- Information -->
        <div style="z-index: 1 !important; background-color: white;">
            <div class="container my py-5">
                <h2 class="h2-responsive text-center mb-5">{{ msg.info.title }}</h2>
                <div class="row">
                    <div class="col-md-4 mb-md-0 mb-5">
                        <div class="row">
                            <div class="col-lg-2 col-md-3 col-2">
                                <i class="fas fa-tablet-alt blue-text fa-2x"></i>
                            </div>
                            <div class="col-lg-10 col-md-9 col-10">
                                <h4 class="h4-responsive">{{ msg.info.section1.title }}</h4>
                                <p>{{ msg.info.section1.text }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 mb-md-0 mb-5">
                        <div class="row">
                            <div class="col-lg-2 col-md-3 col-2">
                                <i class="fas fa-cloud purple-text fa-2x"></i>
                            </div>
                            <div class="col-lg-10 col-md-9 col-10">
                                <h4 class="h4-responsive">{{ msg.info.section2.title }}</h4>
                                <p>{{ msg.info.section2.text }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="container">
            <contact />
        </div>
    </div>
</template>

<script>
    import { lang } from './../language';
    import contact from './../components/Contact';
    export default {
        name: 'Websites',
        components: { contact },
        data() {
            return {
                msg: null,
            }
        },
        created() {
            this.msg = lang.mobileapps_page;
        },
    }
</script>

<style scoped>
    .page-top {
        height: 60vh;
    }

    .pill-1 {
        content: "";
        position: absolute;
        height: 760px;
        width: 1450px;
        border-radius: 780px;
        z-index: -100;
        -webkit-transform: rotate(-60deg);
        transform: rotate(-60deg);
        right: -800px;
        top: -665px;
    }
</style>